var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a,\nbody,\ndiv,\nli,\np,\nspan,\nul,\nli,\ntextarea {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n  font-size: 16px;\n  font-family: 'Biaodian Pro Sans GB', \"Helvetica Neue\", Helvetica, Arial, \"pingfang sc\", \"Hiragino Sans GB\", \"Microsoft YaHei\", \"\\5FAE\\8F6F\\96C5\\9ED1\", STHeiti, SimSun, sans-serif;\n}\nli {\n  list-style: none;\n}\na {\n  text-decoration: none;\n  cursor: pointer;\n}\nul {\n  text-decoration: none;\n}\n.centerBox {\n  margin: 0 auto;\n  width: 1200px;\n  min-width: 1200px;\n}\n@font-face {\n  font-family: Lato;\n  src: url(" + escape(require("../../../static/font/Lato-Regular.svg")) + "), url(" + escape(require("../../../static/font/Lato-Regular.ttf")) + ");\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/assets/less/common.less
// module id = 02ep
// module chunks = 27